// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pivot-table-block-container {
    width: 100%;
    height: 600px;
    border: var(--border);
    border-radius: var(--border-radius);
}

.pivot-table-block-container .table-block-content-box {
    padding: 5px;
    height: calc(100% - 40px);
}

.pivot-table-block-container .ecl-table-block-container {
    transition: height 0.5s ease-in-out;
}

.pivot-modal-container {
    width: 75vw;
    height: 75vh;
}

@media (max-width: 769px) and (orientation: portrait),
(max-height: 769px) and (orientation: landscape) {

    .pivot-modal-container {
        width: 90vw;
        height: 90vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLPivotTable/ECLPivotTable.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI;QACI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".pivot-table-block-container {\r\n    width: 100%;\r\n    height: 600px;\r\n    border: var(--border);\r\n    border-radius: var(--border-radius);\r\n}\r\n\r\n.pivot-table-block-container .table-block-content-box {\r\n    padding: 5px;\r\n    height: calc(100% - 40px);\r\n}\r\n\r\n.pivot-table-block-container .ecl-table-block-container {\r\n    transition: height 0.5s ease-in-out;\r\n}\r\n\r\n.pivot-modal-container {\r\n    width: 75vw;\r\n    height: 75vh;\r\n}\r\n\r\n@media (max-width: 769px) and (orientation: portrait),\r\n(max-height: 769px) and (orientation: landscape) {\r\n\r\n    .pivot-modal-container {\r\n        width: 90vw;\r\n        height: 90vh;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
